const prefix = 'rf';

export {
  prefix,
};
